<template>
  <div class="dashboard-page" :class="{ 'is-mobile': isMobile }">
    <!-- 数据概览卡片 -->
    <div class="stat-card-group">
      <!-- 1：今日总充值 / 总充值 -->
      <div class="stat-card" style="animation-delay: 0s">
        <div class="card-icon blue">
          <img src="../../assets/income.png" alt="icon" />
        </div>
        <div class="card-content">
          <div class="num-group">
            <div class="num-primary">￥{{ animateCount.todayRecharge }}</br><span class="num-secondary">￥{{ animateCount.rechargeAmount }}</span></div>
            <div class="num-divider"></div>
            <div class="num-secondary"></div>
          </div>
          <div class="card-label">今日总充值/总充值</div>
        </div>
      </div>
      <!-- 2：今日线上充值 / 今日线下充值 -->
      <div class="stat-card" style="animation-delay: 0.1s">
        <div class="card-icon green">
          <img src="../../assets/income.png" alt="icon" />
        </div>
        <div class="card-content">
          <div class="num-group">
            <div class="num-primary">
              ￥{{ animateCount.todayOnLineRecharge }}</br>￥{{ animateCount.todayOfflineRecharge }}
            </div>
            <div class="num-divider"></div>
            <div class="num-secondary">
              
            </div>
          </div>
          <div class="card-label">线上充值/线下充值</div>
        </div>
      </div>

      <!-- 3：今日提货 /待发货订单数/ 总提货 -->
      <div class="stat-card" style="animation-delay: 0.2s">
        <div class="card-icon orange">
          <img src="../../assets/pay.png" alt="icon" />
        </div>
        <div class="card-content">
          <div class="num-group">
            <div class="num-primary">{{ animateCount.todayGiveAmount }}</div>
            <div class="num-divider">/</div>
            <div class="num-secondary">
              {{ animateCount.sumGiveAmount }}
            </div>
          </div>
          <div class="card-label">今日赠送金额/总赠送金额</div>
        </div>
      </div>
      <!--4：今日流水 / 总流水 -->
      <div class="stat-card" style="animation-delay: 0.2s">
        <div class="card-icon purple">
          <img src="../../assets/pay.png" alt="icon" />
        </div>
        <div class="card-content">
          <div class="num-group">
             <div class="num-primary">￥{{ animateCount.todayPayPrice }}</br><span class="num-secondary">￥{{ animateCount.sumPayPrice }}</span></div>
            <!-- <div class="num-primary">{{ animateCount.todayPayPrice }}</div>
            <div class="num-divider">/</div>
            <div class="num-secondary">{{ animateCount.sumPayPrice }}</div> -->
          </div>
          <div class="card-label">今日流水/总流水</div>
        </div>
      </div>
       <!--4：总金币 / 总钻石 -->
      <div class="stat-card" style="animation-delay: 0.2s">
        <div class="card-icon pink">
          <img src="../../assets/pay.png" alt="icon" />
        </div>
        <div class="card-content">
          <div class="num-group">
             <div class="num-primary">￥{{ animateCount.balance }}</br><span class="num-secondary">￥{{ animateCount.point }}</span></div>
            <!-- <div class="num-primary">{{ animateCount.todayPayPrice }}</div>
            <div class="num-divider">/</div>
            <div class="num-secondary">{{ animateCount.sumPayPrice }}</div> -->
          </div>
          <div class="card-label">总金币 / 总钻石</div>
        </div>
      </div>
      <!--：赏袋待处理 -->
      <div class="stat-card" style="animation-delay: 0.2s">
        <div class="card-icon red">
          <img src="../../assets/pay.png" alt="icon" />
        </div>
        <div class="card-content">
          <div class="num-group">
            <div class="num-primary">{{ animateCount.prize_price }}</div>
          </div>
          <div class="card-label">赏袋待处理</div>
        </div>
      </div>
    </div>

    <!-- 订单图表 -->
    <div class="chart-wrapper chart-fade-in">
      <div class="chart-container">
        <div ref="order_chart" class="chart-box"></div>
      </div>
    </div>

    <!-- 用户数据图表 -->
    <div class="chart-wrapper chart-fade-in">
      <div class="chart-container flex-row">
        <div ref="user_chart" class="chart-box flex-60"></div>
        <div ref="user_map_chart" class="chart-box flex-40"></div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../api/api.js";
// 引入礼花插件
import confetti from "canvas-confetti";
import { getTheme } from "@/utils/theme";

export default {
  data() {
    return {
      isMobile: false,
      countData: {},
      // 动画数字对象
      animateCount: {
        todayRecharge: 0,
        rechargeAmount: 0,
        todayOnLineRecharge: 0,
        todayOfflineRecharge: 0,
        todayTakeAmount: 0,
        takeAmount: 0,
        wait_delivery_order_num: 0,
        todayPayPrice: 0,
        sumPayPrice: 0,
        prize_price: 0,
        sumGiveAmount:0,
        todayGiveAmount:0,
        balance:0,
        point:0,
      },
      order_chart: "",
      user_chart: "",
      user_map_chart: "",
      isDarkMode: false,

      // ============== 升级：高级炫酷订单图表配置 ==============
      order_option: {
        backgroundColor: "transparent",
        color: ["#3B82F6", "#10B981", "#F59E0B"],
        tooltip: {
          trigger: "axis",
          backgroundColor: "rgba(50,50,50,0.85)",
          borderColor: "transparent",
          textStyle: { color: "#fff" },
          padding: [10, 12],
          borderRadius: 6,
          boxShadow: "0 3px 10px rgba(0,0,0,0.2)",
        },
        legend: {
          data: ["总充金额", "线上金额", "线下金额"],
          top: 10,
          right: 15,
          textStyle: { color: "#555", fontSize: 12 },
          itemWidth: 12,
          itemHeight: 12,
        },
        grid: {
          left: "5%",
          right: "5%",
          bottom: "5%",
          top: "15%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: [],
          axisLine: { lineStyle: { color: "#E5E7EB" } },
          axisLabel: { color: "#6B7280" },
          axisTick: { show: false },
        },
        yAxis: {
          type: "value",
          axisLine: { show: false },
          axisLabel: { color: "#6B7280" },
          splitLine: { lineStyle: { color: "#F3F4F6" } },
        },
        series: [
          {
            name: "总充金额",
            type: "line",
            smooth: true,
            symbol: "circle",
            symbolSize: 7,
            showSymbol: true,
            itemStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#3B82F6" },
                { offset: 1, color: "#60A5FA" },
              ]),
              shadowBlur: 10,
              shadowColor: "rgba(59, 130, 246, 0.3)",
            },
            lineStyle: { width: 3 },
            areaStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "rgba(59, 130, 246, 0.25)" },
                { offset: 1, color: "rgba(59, 130, 246, 0.02)" },
              ]),
            },
            emphasis: {
              symbolSize: 10,
              itemStyle: { shadowBlur: 15 },
            },
            data: [],
          },
          {
            name: "线上金额",
            type: "line",
            smooth: true,
            symbol: "circle",
            symbolSize: 7,
            itemStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#10B981" },
                { offset: 1, color: "#34D399" },
              ]),
              shadowBlur: 10,
              shadowColor: "rgba(16, 185, 129, 0.3)",
            },
            lineStyle: { width: 3 },
            areaStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "rgba(16, 185, 129, 0.25)" },
                { offset: 1, color: "rgba(16, 185, 129, 0.02)" },
              ]),
            },
            emphasis: { symbolSize: 10 },
            data: [],
          },
          {
            name: "线下金额",
            type: "line",
            smooth: true,
            symbol: "circle",
            symbolSize: 7,
            itemStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#F59E0B" },
                { offset: 1, color: "#FBBF24" },
              ]),
              shadowBlur: 10,
              shadowColor: "rgba(245, 158, 11, 0.3)",
            },
            lineStyle: { width: 3 },
            areaStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "rgba(245, 158, 11, 0.25)" },
                { offset: 1, color: "rgba(245, 158, 11, 0.02)" },
              ]),
            },
            emphasis: { symbolSize: 10 },
            data: [],
          },
        ],
      },

      // ============== 升级：高级炫酷会员柱状图配置 ==============
      user_option: {
        backgroundColor: "transparent",
        color: ["#6366F1"],
        tooltip: {
          trigger: "axis",
          backgroundColor: "rgba(50,50,50,0.85)",
          textStyle: { color: "#fff" },
          borderRadius: 6,
          padding: [8, 10],
        },
        grid: {
          left: "5%",
          right: "5%",
          bottom: "5%",
          top: "15%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: [],
          axisLine: { lineStyle: { color: "#E5E7EB" } },
          axisLabel: { color: "#6B7280" },
          axisTick: { show: false },
        },
        yAxis: {
          type: "value",
          axisLine: { show: false },
          axisLabel: { color: "#6B7280" },
          splitLine: { lineStyle: { color: "#F3F4F6" } },
        },
        series: [
          {
            name: "会员数量",
            type: "bar",
            barWidth: "48%",
            itemStyle: {
              borderRadius: [6, 6, 0, 0],
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#818CF8" },
                { offset: 1, color: "#6366F1" },
              ]),
              shadowBlur: 8,
              shadowColor: "rgba(99, 102, 241, 0.25)",
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 15,
                shadowColor: "rgba(99, 102, 241, 0.4)",
              },
            },
            label: {
              show: true,
              position: "top",
              color: "#6366F1",
              fontSize: 11,
              fontWeight: 500,
            },
            data: [],
          },
        ],
      },

      // ============== 升级：高级炫酷会员饼图配置 ==============
      user_map_option: {
        backgroundColor: "transparent",
        tooltip: {
          trigger: "item",
          backgroundColor: "rgba(30,30,30,0.88)",
          borderWidth: 0,
          borderRadius: 8,
          padding: [10, 14],
          textStyle: { color: "#fff", fontSize: 12 },
          formatter: "{b}<br/>数量：{c}<br/>占比：{d}%",
        },
        legend: {
          type: "scroll",
          orient: "horizontal",
          bottom: 8,
          left: "center",
          itemWidth: 10,
          itemHeight: 10,
          textStyle: { color: "#555", fontSize: 12 },
        },
        graphic: [
          {
            type: "text",
            left: "center",
            top: "38%",
            style: {
              text: "总用户",
              fontSize: 12,
              fill: "#888",
              textAlign: "center",
            },
          },
          {
            type: "text",
            left: "center",
            top: "48%",
            style: {
              text: "0",
              fontSize: 24,
              fontWeight: "bold",
              fill: "#1d2129",
              textAlign: "center",
            },
          },
        ],
        series: [
          {
            name: "会员比例",
            type: "pie",
            radius: ["42%", "72%"],
            center: ["50%", "42%"],
            avoidLabelOverlap: true,
            color: [
              "#409EFF",
              "#67C23A",
              "#E6A23C",
              "#F56C6C",
              "#909399",
              "#8E44AD",
              "#2980B9",
              "#D35400",
            ],
            itemStyle: {
              borderRadius: 10,
              borderColor: "#fff",
              borderWidth: 3,
            },
            label: {
              show: true,
              position: "outside",
              fontSize: 11,
              color: "#333",
              formatter: "{b} {d}%",
            },
            labelLine: {
              length: 8,
              length2: 12,
              smooth: true,
            },
            emphasis: {
              scale: true,
              scaleSize: 8,
              itemStyle: {
                shadowBlur: 20,
                shadowColor: "rgba(0,0,0,0.18)",
              },
            },
            data: [],
          },
        ],
      },
    };
  },
  created() {
    this.isDarkMode = getTheme() === "dark";
    this.getCount();
    this.checkDevice();
    // 监听主题切换，更新图表样式
    this.$bus && this.$bus.$on("theme-change", this.onThemeChange);
  },
  mounted() {
    this.ready();
    this.getUser();
    this.getUserMap();
    this.getOrder();
    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
    this.$bus && this.$bus.$off("theme-change", this.onThemeChange);
  },
  methods: {
    // 主题切换回调
    onThemeChange(theme) {
      this.isDarkMode = theme === "dark";
      this.updateChartStyle();
    },
    // 更新图表深浅色样式
    updateChartStyle() {
      const textColor = this.isDarkMode ? "#c0c4cc" : "#6B7280";
      const axisLineColor = this.isDarkMode ? "#4c4d4f" : "#E5E7EB";
      const splitLineColor = this.isDarkMode ? "#333" : "#F3F4F6";
      const legendColor = this.isDarkMode ? "#c0c4cc" : "#555";
      const pieLabelColor = this.isDarkMode ? "#e5eaf3" : "#333";
      const pieCenterText = this.isDarkMode ? "#e5eaf3" : "#1d2129";
      const pieSubText = this.isDarkMode ? "#86909c" : "#888";

      // 订单图表
      this.order_option.legend.textStyle.color = legendColor;
      this.order_option.xAxis.axisLine.lineStyle.color = axisLineColor;
      this.order_option.xAxis.axisLabel.color = textColor;
      this.order_option.yAxis.axisLabel.color = textColor;
      this.order_option.yAxis.splitLine.lineStyle.color = splitLineColor;
      this.order_chart && this.order_chart.setOption(this.order_option);

      // 会员柱状图
      this.user_option.xAxis.axisLine.lineStyle.color = axisLineColor;
      this.user_option.xAxis.axisLabel.color = textColor;
      this.user_option.yAxis.axisLabel.color = textColor;
      this.user_option.yAxis.splitLine.lineStyle.color = splitLineColor;
      this.user_chart && this.user_chart.setOption(this.user_option);

      // 饼图
      this.user_map_option.legend.textStyle.color = legendColor;
      this.user_map_option.series[0].label.color = pieLabelColor;
      this.user_map_option.graphic[0].style.fill = pieSubText;
      this.user_map_option.graphic[1].style.fill = pieCenterText;
      this.user_map_chart && this.user_map_chart.setOption(this.user_map_option);
    },
    // 礼花特效方法
    fireConfetti() {
      const duration = 30000;
      const animationEnd = Date.now() + duration;
      const defaults = {
        startVelocity: 30,
        spread: 360,
        ticks: 60,
        zIndex: 9999,
      };

      function randomInRange(min, max) {
        return Math.random() * (max - min) + min;
      }

      const interval = setInterval(() => {
        const timeLeft = animationEnd - Date.now();
        if (timeLeft <= 0) {
          clearInterval(interval);
          return;
        }
        const particleCount = 50 * (timeLeft / duration);
        confetti({
          ...defaults,
          particleCount,
          origin: { x: randomInRange(0.1, 0.9), y: Math.random() * 0.4 },
        });
        confetti({
          ...defaults,
          particleCount: particleCount / 2,
          origin: { x: randomInRange(0.1, 0.9), y: Math.random() * 0.4 },
        });
      }, 250);
    },
    // 纯 JS 判断设备
    checkDevice() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      const isMobileDevice =
        /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
          userAgent
        );
      const isSmallScreen = window.innerWidth <= 768;
      this.isMobile = isMobileDevice || isSmallScreen;
    },
    // 窗口变化时更新设备状态 + 重绘图表
    onResize() {
      this.checkDevice();
      this.resizeChart();
    },
    ready() {
      this.user_chart = this.$echarts.init(this.$refs.user_chart);
      this.user_map_chart = this.$echarts.init(this.$refs.user_map_chart);
      this.order_chart = this.$echarts.init(this.$refs.order_chart);

      this.user_chart.showLoading();
      this.user_map_chart.showLoading();
      this.order_chart.showLoading();
    },
    resizeChart() {
      if (this.user_chart) this.user_chart.resize();
      if (this.user_map_chart) this.user_map_chart.resize();
      if (this.order_chart) this.order_chart.resize();
    },
    getUser() {
      api.home
        .homeUserRegister()
        .then((res) => {
          if (res.data.code === "1000") {
            const list = res.data.data;
            const xData = list.map((item) => item.date);
            const yData = list.map((item) => item.count);

            this.user_option.xAxis.data = xData;
            this.user_option.series[0].data = yData;

            this.user_chart.hideLoading();
            this.user_chart.setOption(this.user_option);
            this.updateChartStyle();
          }
        })
        .catch((error) => {
          console.error("会员数据图表接口请求失败", error);
        });
    },
    getUserMap() {
      api.home
        .homeUserMap()
        .then((res) => {
          if (res.data.code === "1000") {
            const pieData = res.data.data;
            this.user_map_option.series[0].data = pieData;

            // 计算总和，填入圆环中心文字
            const total = pieData.reduce(
              (sum, item) => sum + Number(item.value),
              0
            );
            this.user_map_option.graphic[1].style.text = total.toLocaleString();

            this.user_map_chart.hideLoading();
            this.user_map_chart.setOption(this.user_map_option);
            this.updateChartStyle();
          }
        })
        .catch((error) => {
          console.error("会员饼图图表接口请求失败", error);
        });
    },
    async getOrder() {
      try {
        const res = await api.home.homeWeekRecharge();
        if (res.data.code === "1000") {
          const list = res.data.data;
          const xData = list.map((item) => item.date);
          const totalRecharge = list.map((item) => item.todayRecharge);
          const onlineRecharge = list.map((item) => item.todayOnLineRecharge);
          const offlineRecharge = list.map((item) => item.todayOfflineRecharge);

          this.order_option.xAxis.data = xData;
          this.order_option.series[0].data = totalRecharge;
          this.order_option.series[1].data = onlineRecharge;
          this.order_option.series[2].data = offlineRecharge;

          this.order_chart.hideLoading();
          this.order_chart.setOption(this.order_option);
          this.updateChartStyle();
        }
      } catch (error) {
        console.error("周充值图表接口请求失败", error);
      }
    },
    async getCount() {
      console.log("========= 开始调用首页接口 =========");
      try {
        const res = await api.home.homePageCount();
        console.log("接口返回结果：", res);
        if (res.data.code == 1000) {
          this.countData = res.data.data;
          console.log("最终渲染数据：", this.countData);

          // 今日充值 > 50000 放礼花
          const todayRechargeValue = Number(this.countData.todayRecharge) || 0;
          if (todayRechargeValue > 50000) {
            this.fireConfetti();
          }

          // 数字滚动动画
          this.startCountAnimation();
        }
      } catch (error) {
        console.error("接口请求失败！！！", error);
      }
    },
    // 数字滚动动画核心方法
    startCountAnimation() {
      const duration = 1200;
      const step = 20;
      const totalFrames = duration / step;

      Object.keys(this.animateCount).forEach((key) => {
        const target = Number(this.countData[key]) || 0;
        let currentFrame = 0;

        const timer = setInterval(() => {
          currentFrame++;
          const progress = currentFrame / totalFrames;
          this.animateCount[key] = Math.floor(target * progress);

          if (currentFrame >= totalFrames) {
            this.animateCount[key] = target;
            clearInterval(timer);
          }
        }, step);
      });
    },
  },
};
</script>

<style lang="less" scoped>
/* ====================== 默认 PC 样式 ====================== */
.dashboard-page {
  background: var(--bg-page);
  min-height: 100vh;
  padding: 28px 32px;
  box-sizing: border-box;

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  @keyframes chartFade {
    from {
      opacity: 0;
      transform: scale(0.96);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }

  .chart-fade-in {
    animation: chartFade 0.6s ease forwards;
    animation-delay: 0.4s;
    opacity: 0;
  }

  .stat-card-group {
    display: flex;
    flex-wrap: wrap;
    gap: 22px;
    margin-bottom: 28px;
  }

  .stat-card {
    flex: 1;
    min-width: 280px;
    background: var(--bg-card);
    border: 1px solid var(--border-base);
    border-radius: 20px;
    padding: 26px;
    display: flex;
    align-items: center;
    gap: 20px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
    opacity: 0;
    animation: fadeInUp 0.5s ease forwards;

    &:hover {
      transform: translateY(-6px);
      box-shadow: 0 14px 32px rgba(0, 0, 0, 0.1);
    }

    .card-icon {
      width: 58px;
      height: 58px;
      border-radius: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;

      &.blue {
        background: linear-gradient(135deg, #409eff 0%, #6fb5ff 100%);
      }
      &.green {
        background: linear-gradient(135deg, #67c23a 0%, #95d76d 100%);
      }
      &.orange {
        background: linear-gradient(135deg, #e6a23c 0%, #f0b764 100%);
      }
      &.purple {
        background: linear-gradient(135deg, #9064e5 0%, #b48eff 100%);
      }
      &.pink {
        background: linear-gradient(135deg, #e6a23c 0%, #6fb5ff 100%);
      }
      &.red {
        background: linear-gradient(135deg, #f56c6c 0%, #ff8888 100%);
      }

      img {
        width: 28px;
        height: 28px;
        object-fit: contain;
        filter: brightness(0) invert(1);
      }
    }

    .card-content {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 6px;
    }

    .num-group {
      display: flex;
      align-items: baseline;
      gap: 6px;
    }

    .num-primary {
      font-size: 20px;
      font-weight: 700;
      color: var(--text-primary);
      line-height: 1.2;
    }

    .num-divider {
      font-size: 16px;
      color: var(--text-secondary);
    }

    .num-secondary {
      font-size: 16px;
      font-weight: 500;
      color: var(--text-regular);
    }

    .card-label {
      font-size: 14px;
      color: var(--text-secondary);
      margin-top: 4px;
    }
  }

  .chart-wrapper {
    margin-bottom: 28px;
  }

  .chart-container {
    background: var(--bg-card);
    border: 1px solid var(--border-base);
    border-radius: 20px;
    height: 420px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
    transition: box-shadow 0.3s ease;
    overflow: hidden;

    &:hover {
      box-shadow: 0 12px 30px rgba(0, 0, 0, 0.1);
    }

    &.flex-row {
      display: flex;
    }
  }

  .flex-60 {
    flex: 0 0 60%;
  }
  .flex-40 {
    flex: 0 0 40%;
  }

  .chart-box {
    width: 100%;
    height: 100%;
  }

  /* ====================== 移动端样式 ====================== */
  &.is-mobile {
    padding: 16px;

    .stat-card-group {
      flex-direction: column;
      gap: 16px;
      margin-bottom: 20px;
    }

    .stat-card {
      min-width: auto;
      padding: 20px;
      gap: 16px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);

      .card-icon {
        width: 52px;
        height: 52px;
        img {
          width: 24px;
          height: 24px;
        }
      }

      .num-primary {
        font-size: 18px;
      }
      .num-secondary,
      .num-divider {
        font-size: 15px;
      }
      .card-label {
        font-size: 13px;
      }
    }

    .chart-wrapper {
      margin-bottom: 20px;
    }

    .chart-container {
      height: auto;
      border-radius: 16px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);

      &.flex-row {
        flex-direction: column;
        .flex-60,
        .flex-40 {
          width: 100%;
          height: 340px;
        }
      }
    }

    .chart-box {
      height: 340px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/index/index.vue